module.exports = __webpack_public_path__ + "media/images/logo_dark-31c3875ab94b034df74cea6568855ed1.png";